import { Button, Input } from '@aidkitorg/component-library';
import { useState } from 'react';
import { usePost } from './API';

export function PdfComponent() {
  const createPdf = usePost('/document/create_pdf');
  const [uid, setUid] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [subsurveyPath, setSubsurveyPath] = useState('');

  const downloadPdf = async () => {
    if (!uid || !subsurveyPath) return;

    setIsLoading(true);
    setError(null);

    try {
      const response = await createPdf({ uid, subsurveyPath, lang: 'en' });
      if (!response) {
        setError('No response from server');
        return;
      }

      if (response.error) {
        setError(response.error);
        return;
      }

      window.open(response.signedUrl, '_blank');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to download PDF');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="w-full h-full p-4">
      <p className="mb-4 text-red-500">This feature is currently in beta and will not work for all applications at this time. Reach out to Riley for any questions</p>
      <p className="mb-4">Enter a UID and subsurvey path to generate a PDF for the application form.</p>

      <div className="mt-4 text-sm text-gray-600">
        <Input label="UID" value={uid} onChange={(e) => setUid(e.target.value)} className="mb-4" />
        <Input label="Subsurvey Path" value={subsurveyPath} onChange={(e) => setSubsurveyPath(e.target.value)} className="mb-4" />
      </div>

      {error && (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded my-4">
          Error: {error}
        </div>
      )}

      <div className="my-4">
        <Button
          onClick={downloadPdf}
          isDisabled={isLoading || !uid || !subsurveyPath}
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded disabled:opacity-50"
        >
          {isLoading ? 'Generating PDF...' : 'Download PDF'}
        </Button>
      </div>
    </div>
  );
}